<!--
 * @Descripttion: 轮播表
 * @Author: zenghua.wang
 * @Date: 2021-10-19 09:07:03
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-23 16:09:46
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
    v-custom-loading="loading"
    :custom-loading-text="component.loadingText"
    :custom-loading-spinner="component.loadingSpinner"
    :custom-loading-background="component.loadingBackground"
  >
    <div
      :class="setClass('header')"
      :style="styleHeader"
      v-if="option.showHeader"
    >
      <div
        v-if="option.index"
        :class="setClass('header__item')"
        :style="styleColumn(indexWidth)"
      >
        {{option.indexHeader}}
      </div>
      <div
        :class="setClass('header__item')"
        v-for="(column, cindex) in columnList"
        :key="cindex"
        :style="styleColumn(column.width, column.align)"
      >{{column.label}}
      </div>
    </div>

    <div
      :class="setClass('body')"
      :style="styleBody"
    >
      <div
        :class="setClass('row')"
        v-for="(item, rowIndex) in dataList"
        :key="item"
        :style="styleRow(rowIndex)"
      >
        <div
          v-if="option.index"
          :class="setClass('row__item')"
          :style="styleColumn(indexWidth)"
        >
          <span
            class="circle"
            :style="styleCircle(item.index)"
          >{{item.index}}
          </span>
        </div>
        <div
          :class="setClass('row__item')"
          v-for="(column, columnIndex) in columnList"
          :key="columnIndex"
          :style="styleColumn(column.width, column.align)"
        >
          <span
            v-if="['select','cascader'].includes(column.type)"
            :style="styleColor(column.color)"
            v-text="formatDictory(column, item)"
          >
          </span>
          <span
            v-else
            :style="styleColor(column.color)"
          >
            {{item[column.prop]}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bem from '@/dragComponents/mixins/bem'
import customLoading from '@/dragComponents/directive/loading'
import { isEmpty, setPx, getDictoryByEqual } from '@/dragComponents/utils'
import { component } from '@/dragComponents/model/default.js'
import mock from '@/dragComponents/model/mock.js'

export default {
  name: 'drag-scrollboad',
  mixins: [bem],
  components: {},
  directives: { customLoading },
  inject: ['category'],
  props: {
    id: {
      type: String
    },
    apiId: {
      type: [Number, String]
    },
    width: {
      type: [Number, String],
      default: 600
    },
    height: {
      type: [Number, String],
      default: 200
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      component: component,
      indexWidth: 80,
      animationIndex: 0,
      animationHandler: null,
      scrollboadHandle: null,
      rowsData: [],
      dataList: [],
      heights: []
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: this.category === 'report' ? this.width : setPx(this.width),
          height: setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleHeader() {
      return {
        height: setPx(this.avgHeight),
        lineHeight: setPx(this.avgHeight),
        textAlign: 'center',
        fontSize: setPx(this.option.headerFontSize),
        fontWeight: this.option.headerFontWeight,
        color: this.option.headerColor,
        backgroundColor: this.option.headerBackgroundColor
      }
    },
    styleBody() {
      let height = this.height - (this.option.showHeader ? this.avgHeight : 0)
      return {
        width: this.category === 'report' ? this.width : setPx(this.width),
        height: setPx(height)
      }
    },
    styleRow() {
      return (index) => {
        let { carousel, rowNum } = this.option
        return {
          height: setPx(this.heights[index]),
          lineHeight: setPx(this.heights[index]),
          textAlign: 'center',
          fontSize: setPx(this.option.rowFontSize),
          opacity:
            carousel === 'page'
              ? this.animationHandler && index < rowNum
                ? '0'
                : '1'
              : this.animationHandler && index === 0
                ? '0'
                : '1',
          color: this.option.rowColor,
          backgroundColor:
            index % 2 === 0
              ? this.option.evenRowBackgroundColor
              : this.option.oddRowBackgroundColor
        }
      }
    },
    styleCircle() {
      let margin = 16
      let circleWidth = this.avgHeight - margin
      return (index) => {
        return Object.assign(
          (() => {
            let style = {}
            switch (this.option.indexStyle) {
              case 'color':
                style = {
                  color: this.getColor(index - 1)
                }
                break
              case 'backgroundColor':
                if (this.option.defaultColor) {
                  style = {}
                } else {
                  style = {
                    backgroundColor: !isEmpty(this.option.color)
                      ? this.getColor(index - 1)
                      : 'rgba(255,255,255,0)',
                    color:
                      index - 1 >= this.option.color.length
                        ? this.option.rowColor
                        : '#fff'
                  }
                }
                break
              default:
                style = {}
            }
            return style
          })(),
          {
            width: setPx(circleWidth),
            height: setPx(circleWidth),
            lineHeight: setPx(circleWidth),
            marginTop: setPx(margin / 2)
          }
        )
      }
    },
    len() {
      return this.rowsData.length
    },
    count() {
      let headerNum = this.option.showHeader ? 1 : 0
      let rowNum = this.option.rowNum || 10
      return rowNum + headerNum
    },
    avgHeight() {
      return parseInt(this.height / this.count)
    },
    columnList() {
      return !isEmpty(this.option.column)
        ? this.option.column
        : mock.scrollboad.column
    }
  },
  watch: {
    apiId() {
      this.loadDataList()
    },
    height() {
      this.stopAnimation()
      this.setOption()
    },
    option: {
      handler() {
        this.stopAnimation()
        this.setOption()
      },
      deep: true,
      immediate: true
    },
    'option.column': {
      handler(list) {
        this.columnList = list
      },
      deep: true,
      immediate: true
    },
    'option.rowNum'() {
      this.heights = new Array(this.len).fill(this.avgHeight)
    },
    'option.refresh'(val) {
      if (val) this.loadDataList()
    }
  },
  methods: {
    styleColumn(width, align = 'center') {
      return {
        width: setPx(width),
        flex: width === 'auto' ? 1 : '',
        textAlign: align
      }
    },
    styleColor(color = '') {
      return {
        color: isEmpty(color) ? this.option.rowColor : color
      }
    },
    // 下拉、级联字典解析
    formatDictory(item, row) {
      let text =
        getDictoryByEqual(item.dicData, row[item.prop]) || row[item.prop]
      return text
    },
    getColor(index) {
      let { defaultColor, rowColor, color } = this.option
      if (defaultColor) return rowColor
      return !isEmpty(color) ? color[index] : rowColor
    },
    async loadDataList() {
      if (!this.apiId) {
        this.init()
        return
      }
      // 参数设置
      let restParams = []
      let query = {}

      // 过滤条件
      this.option.reqParams.map((item, index) => {
        // 外部条件、参数
        if (!isEmpty(item.key) && !isEmpty(this.$route.query[item.key])) {
          query[item.prop] = this.$route.query[item.key]
        }

        // 固定值、登录人等非空查询
        if (!isEmpty(item.value)) {
          query[item.prop] = item.value
        }
      })

      try {
        this.loading = true
        let res = await this.$http({
          method: this.option.reqMethod,
          url: mock.getUrl(false) + this.apiId,
          data: restParams,
          params: query
        })
        if (!isEmpty(res.data)) {
          this.rowsData = res.data
          this.setOption()
          this.onRefresh()
        }
      } catch (err) {
        this.$message.error(err.msg)
      } finally {
        this.loading = false
        this.option.refresh = false
      }
    },
    setOption() {
      this.rowsData.forEach((item, index) => {
        item.index = index + 1
      })
      this.heights = new Array(this.len).fill(this.avgHeight)
      this.dataList = this.rowsData
      this.startAnimation(true)
    },
    onRefresh() {
      this.scrollboadHandle && clearInterval(this.scrollboadHandle)
      this.scrollboadHandle = null
      if (this.option.refreshTime > 0 && this.disabled) {
        this.scrollboadHandle = setInterval(() => {
          this.loadDataList()
        }, this.option.refreshTime)
      }
    },
    async startAnimation(start = false) {
      let { animation, animationTime, rowNum, carousel } = this.option
      let { animationIndex, avgHeight, rowsData, len } = this
      let animationNum = carousel === 'single' ? 1 : rowNum
      let bool = carousel === 'single' ? rowNum >= len : len < rowNum * 2
      if (!animation || bool) return
      if (start) {
        await new Promise((resolve) => setTimeout(resolve, animationTime))
      }
      let rows = rowsData.slice(animationIndex)
      rows.push(...rowsData.slice(0, animationIndex))
      this.dataList = rows.slice(
        0,
        carousel === 'page' ? rowNum * 2 : rowNum + 1
      )
      this.heights = new Array(len).fill(avgHeight)
      await new Promise((resolve) => setTimeout(resolve, 100))
      this.heights.splice(0, animationNum, ...new Array(animationNum).fill(0))
      animationIndex += animationNum
      let animationBack = animationIndex - len
      if (animationBack >= 0) animationIndex = animationBack
      // console.log(animationIndex, this.dataList, this.heights)
      this.animationIndex = animationIndex
      this.animationHandler = setTimeout(
        this.startAnimation,
        animationTime - 100
      )
    },
    stopAnimation() {
      if (this.animationHandler) {
        clearTimeout(this.animationHandler)
        this.animationHandler = null
      }
    },
    init() {
      this.columnList = mock.scrollboad.column
      this.rowsData = mock.scrollboad.rowsData
      this.setOption()
    }
  },
  created() {
    this.loadDataList()
  },
  destroyed() {
    this.stopAnimation()
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/variables.scss';

.drag-scrollboad {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  &-header {
    display: flex;
    flex-direction: row;
    text-align: 'center';
    font-size: 14px;

    &__item {
      padding: 0 10px;
      transition: all 0.3s;
      box-sizing: border-box;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &-body {
    overflow: hidden;
  }

  &-row {
    display: flex;
    flex-direction: row;
    text-align: 'center';
    font-size: 12px;
    transition: all 0.3s;

    &__item {
      box-sizing: border-box;
      padding: 0 10px;
      @include ellipsis();

      span {
        display: block;
        width: 100%;
        height: 100%;
        @include ellipsis();
      }

      .circle {
        box-sizing: border-box;
        margin: 0 auto;
        text-align: center;
        border-radius: 999px;
      }
    }
  }
}
</style>
